import React from 'react'
import { Page } from '@homeviews/analytics'

export const Analytics = () => <Page />
